import { NgModule } from '@angular/core';
// import {ScrollingModule} from '@angular/cdk/scrolling';
// import {MatBadgeModule} from '@angular/material/badge';
// import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
// import {MatProgressBarModule} from '@angular/material/progress-bar';
// import {MatSliderModule} from '@angular/material/slider';
// import {MatStepperModule} from '@angular/material/stepper';
// import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
// import {MatChipsModule} from '@angular/material/chips';
// import {MatDatepickerModule} from '@angular/material/datepicker';
// import {MatGridListModule} from '@angular/material/grid-list';
// import {MatSidenavModule} from '@angular/material/sidenav';
// import {MatSlideToggleModule} from '@angular/material/slide-toggle';
// import {MatDividerModule} from '@angular/material/divider';
 import {MatMenuModule} from '@angular/material/menu';
// import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatListModule} from '@angular/material/list';
import {MatTabsModule} from '@angular/material/tabs';
import {MatRadioModule} from '@angular/material/radio';
import {MatExpansionModule} from '@angular/material/expansion';
import {CdkTreeModule} from '@angular/cdk/tree';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTreeModule} from '@angular/material/tree';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatDividerModule} from '@angular/material/divider';

@NgModule({
  exports: [
    MatAutocompleteModule,
    DragDropModule,
    CdkTreeModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatTreeModule,
    MatExpansionModule,
    MatRadioModule,
    MatTabsModule,
    MatListModule,
    MatSnackBarModule,
    MatPaginatorModule,
    MatMenuModule,
    MatDividerModule
  ]
})
export class MaterialModule { }
